import { useEffect, useRef, useState } from 'react';
import { registerSW } from 'virtual:pwa-register';

type UpdateServiceWorker = (reloadPage?: boolean) => Promise<void>;

/**
 * Evita que una pestaña instalada siga usando un bundle anterior mientras el
 * API ya cambió sus contratos. El usuario decide cuándo recargar para no
 * perder un formulario que esté llenando.
 */
export function PwaUpdatePrompt() {
  const [updateAvailable, setUpdateAvailable] = useState(false);
  const updateRef = useRef<UpdateServiceWorker | null>(null);

  useEffect(() => {
    let updateTimer: number | undefined;
    const updateSW = registerSW({
      onNeedRefresh: () => setUpdateAvailable(true),
      onRegisteredSW: (_swUrl, registration) => {
        if (!registration) return;
        updateTimer = window.setInterval(() => void registration.update(), 60 * 60 * 1000);
      },
    });
    updateRef.current = updateSW;
    return () => {
      if (updateTimer !== undefined) window.clearInterval(updateTimer);
    };
  }, []);

  if (!updateAvailable) return null;

  return (
    <div className="fixed inset-x-4 bottom-[calc(6.5rem+env(safe-area-inset-bottom))] z-[70] mx-auto max-w-md rounded-2xl border border-slate-200 bg-white p-4 shadow-xl lg:bottom-6">
      <p className="text-sm font-semibold text-slate-900">Hay una actualización disponible</p>
      <p className="mt-1 text-sm leading-5 text-slate-600">
        Recarga antes de seguir para usar la versión más reciente de la app.
      </p>
      <div className="mt-3 flex justify-end gap-2">
        <button
          type="button"
          onClick={() => setUpdateAvailable(false)}
          className="tap-target rounded-lg px-3 py-2 text-sm font-semibold text-slate-600 hover:bg-slate-100"
        >
          Después
        </button>
        <button
          type="button"
          onClick={() => void updateRef.current?.(true)}
          className="tap-target rounded-lg bg-slate-900 px-3 py-2 text-sm font-semibold text-white hover:bg-slate-800"
        >
          Recargar
        </button>
      </div>
    </div>
  );
}
